export default "__VITE_ASSET__Dn471ZIU__"